import { adminProjectWeeklySummaryKpiResponseSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  enabled?: boolean;
}

export function useAdminProjectWeeklySummaryKpi({ enabled = true }: Params = {}) {
  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getAdminProjectWeeklySummaryKpi(),
    queryFn: () =>
      get({
        url: '/admin/project-weekly-summary-kpi',
        schema: adminProjectWeeklySummaryKpiResponseSchema,
      }),
    enabled,
  });

  return {
    weeklySummaryKpi: data,
    error,
    isLoading,
  };
}
